export default class  UpdateBackOrderStatu{
    id: number;
    orderStatus: number;
    reMark: string;
    abnormalImageUploadGuid: string;
    salesmanId?: number;
    orderNumber: string;
}